<template>
    <div class="boats-grid">
        <BoatItem
            v-for="(boat, index) in boats"
            :key="boat.id"
            :boat="boat"
            :boatIndex="++index"
        ></BoatItem>
    </div>
</template>

<script>
    import BoatItem from "./BoatItem";
    import { BoatService } from '@/js/services';

    export default {
        name: "BoatList",
        components: {
            BoatItem
        },
        data() {
            return {
                boats: [],
            }
        },
        mounted() {
            this.getBoats();
        },
        methods: {
            async getBoats() {
                try {
                    const { data: { data: boats } } = await BoatService.getBoats();

                    this.boats = boats;
                } catch (e) {
                    throw new Error(e)
                }
            }
        }
    }
</script>
